/**
 * Akıllı upsell sıralaması — sepet çekmecesi önerileri.
 * Kargo eşiğine kalan tutarı (`remaining`) TEK ürünle kapatacak adaylar
 * önce (ucuzdan pahalıya), sonra kalanı dolduracak en ucuz tamamlayıcılar
 * gösterilir. Fiyatı 0 ürünler havuza girmez (IB5).
 */
export type UpsellCandidate = { slug: string; price: number };

export function rankUpsellSuggestions(
  candidates: UpsellCandidate[],
  remaining: number,
  limit = 5
): UpsellCandidate[] {
  const priced = candidates.filter((c) => c && typeof c.slug === "string" && c.price > 0);
  const cap = Math.max(1, Math.min(20, Math.floor(limit) || 5));
  if (remaining <= 0) {
    // Eşik aşılmış — en ucuz tamamlayıcılarla sepeti büyüt
    return [...priced].sort((a, b) => a.price - b.price).slice(0, cap);
  }
  const closers = priced
    .filter((c) => c.price >= remaining)
    .sort((a, b) => a.price - b.price);
  const fillers = priced
    .filter((c) => c.price < remaining)
    .sort((a, b) => a.price - b.price);
  return [...closers, ...fillers].slice(0, cap);
}
